<script>
  import { createEventDispatcher } from 'svelte';
  import { removeBlockedUser } from '../../../Api/api';

  const dispatch = createEventDispatcher();

  export let blockedUsers = [];

  const onRemoveBlock = async (userId) => {
    await removeBlockedUser(userId);
  };
</script>

<div class="blocked-users">
  <header>
    <h1>Blokkerte brukere</h1>
    <div class="controls">
      <button on:click={() => dispatch('close')}><span class="material-icons">close</span></button>
    </div>
  </header>
  <div class="list">
    {#each blockedUsers as user}
      <div class="user">
        <span>{user.userName}</span>
        <button on:click={() => onRemoveBlock(user.id)}>Fjern blokkering</button>
      </div>
    {/each}
  </div>
</div>

<style src="./blockedUsers.scss"></style>
